<!--  -->
<template>
  <div class="total">
    <div class="title">
      <!-- <span class="demonstration">默认 Hover 指示器触发</span> -->
      <el-carousel height="6.9rem" style="position: relative">
        <el-carousel-item v-for="(item, index) in title" :key="item.url">
          <!-- <h3 class="small">{{ item }}</h3> -->
          <button v-show="index != 0" @click="goto(index)" class="title-btn">
            点 击 加 入
          </button>
          <img width="100%" height="100%" :src="item.url" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div style="margin: 80px 0">
        <h3 class="content-title">数据驱动医疗服务产品</h3>
        <div>DATA DRIVEN MEDICAI SERVICE PRODUCTS</div>
      </div>
    </div>
    <div class="content">
      <div class="contentImg">
        <div v-for="item in imgData" :key="item" class="contentImg-box">
          <img class="contentImg-img" :src="item" alt="" />
        </div>
      </div>

      <img
        style="position: absolute; top: 1.5rem; width: 4.8rem; margin: 0 7.2rem"
        src="@/../static/img/homeTwo.png"
        alt=""
      />
    </div>

    <!-- <img style="width: 100%" src="@/../static/img/twoimg.jpg" alt="" /> -->
    <img
      style="width: 100%"
      @click="showVideo"
      src="@/../static/img/videoimg.jpg"
      alt=""
    />

    <!-- <div class="video">
      <video
        class="video-title"
        src="https://comtcare-pub.oss-cn-hangzhou.aliyuncs.com/official-website/video/%E5%8C%A1%E6%B5%8E%E5%8C%BB%E5%AD%A6%E7%A7%91%E6%8A%80%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0V1.0.mp4"
        muted
        autoplay="autoplay"
      ></video>
      <div class="video-icon">
        <img
          style="width: 80px"
          @click="dialogVisible = true"
          src="@/../static/img/play.png"
          alt=""
        />
        <i style="font-size: 80px; color: #fff" class="el-icon-video-play"></i>
      </div>
    </div> -->
    <!-- <el-collapse-transition>
      <div class="video-title" v-show="dialogVisible">
        <video
          id="fullscreen-btn"
          style="width: 60%；margin: 20%;"
          src="https://comtcare-pub.oss-cn-hangzhou.aliyuncs.com/official-website/video/%E5%8C%A1%E6%B5%8E%E5%8C%BB%E5%AD%A6%E7%A7%91%E6%8A%80%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0V1.0.mp4"
          preload="meta"
          controls="controls"
        ></video>
      </div>
          title="打造“互联网+医疗健康”标杆企业"
    </el-collapse-transition> -->

    <el-dialog
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      width="75%"
      style="margin-top: -8vh"
    >
      <video
        id="myAudio"
        style="width: 100%"
        src="https://comtcare-pub.oss-cn-hangzhou.aliyuncs.com/official-website/video/%E5%8C%A1%E6%B5%8E%E5%8C%BB%E5%AD%A6%E7%A7%91%E6%8A%80%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0V2.0.mp4"
        preload="meta"
        autoplay="autoplay"
        controls="controls"
      ></video>
    </el-dialog>
    <img
      style="width: 100%"
      @click="showVideo"
      src="@/../static/img/cooperativePartner.jpg"
      alt=""
    />

    <!-- <el-button @click="twe" type="primary">主要按钮</el-button> -->
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      imgData: [
        "@/../static/img/home/1.png",
        "@/../static/img/home/2.png",
        "@/../static/img/home/3.png",
        "@/../static/img/home/4.png",
        "@/../static/img/home/5.png",
        "@/../static/img/home/6.png",
      ],
      dialogVisible: false,
      title: [
        {
          url: "@/../static/img/title1.jpg",
        },
        {
          url: "@/../static/img/title2.jpg",
        },
        {
          url: "@/../static/img/title3.jpg",
        },
      ],
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    handleClose() {
      var x = document.getElementById("myAudio");

      x.pause();
      this.dialogVisible = false;
    },
    goto(index) {
      if (index == 1) {
        this.$router.push({ path: "/partner" });
      }
      if (index == 2) {
        this.$router.push({ path: "/jobs" });
      }
    },
    showVideo() {
      this.dialogVisible = true;
      var x = document.getElementById("myAudio");

      x.play();
    },
  },
};
</script>
<style lang='less' scoped>
.total {
  width: 100%;
  height: 100%;
  margin-bottom: 80px;
}
.title {
  width: 100%;
  height: 100%;
  .title-btn {
    width: 3.2rem;
    height: 0.8rem;
    position: absolute;
    top: 4.4rem;
    left: 12rem;
    font-size: 30px;
    color: rgb(255, 255, 255, 0.3);
    border: 2px solid rgb(255, 255, 255);
    border-radius: 8px;
    background-color: #03265c;
    opacity: 0.3;
    z-index: 100;
  }
  .title-btn:hover {
    width: 3.2rem;
    height: 0.8rem;
    position: absolute;
    top: 4.4rem;
    left: 12rem;
    font-size: 30px;
    color: rgb(255, 255, 255, 0.7);
    border: 2px solid rgb(255, 255, 255);
    border-radius: 8px;
    background-color: #03265c;
    opacity: 0.7;
    z-index: 100;
  }
  .title-logo {
    width: 2rem;
    margin: 14px 1.5rem 14px 4.7rem;
  }
}
.showUp {
  -webkit-animation-duration: 1.2s;
  animation-duration: 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  // animation: 0.6s rainbow infinite;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-name: showUp;
  animation-name: showUp;
}
@keyframes showUp {
  0% {
    opacity: 0;
    width: 100px;
    height: 100px;
    // -webkit-transform: translate(600px, 600px);
    // transform: translate(600px, 600px);
  }
  100% {
    opacity: 1;
    width: 100%;
    height: 100%;
    // -webkit-transform: translate(0, 0);
    // transform: translate(0, 0);
  }
}
.content-title {
  color: #464c4f;
  font-size: 30px;
}
.content {
  width: 100%;
  margin: 0.8rem 0;
  position: relative;
  .contentImg {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .contentImg-box {
    width: 5.3rem;
    height: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.15rem 1.8rem;
    // overflow: hidden;
  }
  .contentImg-img {
    width: 100%;
    transition: all 0.3s;
  }
  .contentImg-img:hover {
    width: 110%;
  }
}

.video {
  width: 100%;
  height: 4.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url(../../static/img/videoBgimg.png) no-repeat;
  // background-image: url("../../static/img/videoBgimg.png");
  background-size: 100%;
  position: relative;
}
.video-icon {
  position: absolute;
  top: 10;
  width: 100%;
  height: 470px;
  opacity: 0.3;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}
.video-title {
  // position: fixed;
  // top: 0;
  // width: 5rem;
  height: 600px;
  background-color: rgb(255, 255, 255, 0.7);
  z-index: 100;

  // margin: 0 auto;
}
.el-dialog__wrapper/deep/.el-dialog {
  margin-top: 5vh;
  margin: auto;
}
.el-dialog__wrapper/deep/.el-dialog__body {
  padding: 0;
  background-color: rgb(0, 0, 0, 0.3);
}
.el-dialog__wrapper/deep/.el-dialog__header {
  padding: 0;
}
.el-dialog__wrapper/deep/.el-icon-close {
  color: #fff;
  font-size: 20px;
}
.el-dialog__wrapper/deep/.el-dialog__headerbtn {
  top: 10px;
  right: 10px;
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue